import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "choix-site-satisfaction" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectSite = _resolveComponent("SelectSite")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SelectSite, {
      "is-multi-site": _ctx.isMultiSite,
      "selected-sites": _ctx.sites,
      selectedSite: _ctx.site,
      "sites-disabled": false,
      "societe-id": _ctx.getSocieteId,
      title: '',
      class: "select-site-container",
      onAdd: _ctx.addSite,
      onAddAll: _ctx.addAllSite,
      onPick: _ctx.pick,
      onFilterChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.pick(undefined)))
    }, null, 8, ["is-multi-site", "selected-sites", "selectedSite", "societe-id", "onAdd", "onAddAll", "onPick"])
  ]))
}